import { GET_CON_CAPACITY_ALL, GET_CON_CAPACITY_EDIT_HISTORY, RESET_CON_CAPACITY, SET_CONSUMER_DETAILS, SET_ENERGY_TYPE_DETAILS } from './types';

const initialState = {
}

const consumerCapacityReducer = (state = initialState, action) => {
    if (action.type) {
        switch (action.type) {
            case GET_CON_CAPACITY_ALL:
                return {
                    ...state,
                    allConCapacity: action.payload
                }
            case SET_CONSUMER_DETAILS:
                return {
                    ...state,
                    consumerDetails: action.payload
                }
            case SET_ENERGY_TYPE_DETAILS:
                return{
                    ...state,
                    energyTypes: action.payload
                }
                case GET_CON_CAPACITY_EDIT_HISTORY:
                return {
                    ...state,
                    conCapacityEditHistory: action.payload
                }
                case RESET_CON_CAPACITY:
                return initialState;
            default:
                {
                    return state;
                }
        }
    }
}

export default consumerCapacityReducer;